import { render, staticRenderFns } from "./smallMap.vue?vue&type=template&id=cb814128&scoped=true"
import script from "./smallMap.vue?vue&type=script&lang=js"
export * from "./smallMap.vue?vue&type=script&lang=js"
import style0 from "./smallMap.vue?vue&type=style&index=0&id=cb814128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb814128",
  null
  
)

export default component.exports